module.exports = __webpack_public_path__ + "static/media/71.79c3656a.jpg";